import {
  TruespeedConfigFieldMapping as ConfigFieldMapping,
  TRANSMIT_INTERFACE_VALUE,
  definedAddressValue
} from '../tabs/models/model';
import { AGENT_MODEL, TestMode } from '@nrwl/common-lib';
export const TRUESPEED_AGENT_MODEL_CONFIG = {
  id: 'truespeed_test',
  agentConfig: {
    default: {
      setup: {
        alias: {
          enabled: true,
          value: 'Truespeed',
          outputField: 'alias',
          tabId: 'truespeed_setup',
          restoreOnAgentChange: true
        },
        shaId: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.SHA_ID,
          tabId: 'truespeed_setup',
          outputOptional: true
        },
        customer: {
          enabled: true,
          value: '',
          outputField: 'customer',
          tabId: 'truespeed_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        technician: {
          enabled: true,
          value: '',
          outputField: 'technician',
          tabId: 'truespeed_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        contact: {
          enabled: true,
          value: '',
          outputField: 'contact',
          tabId: 'truespeed_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        email: {
          enabled: true,
          value: '',
          outputField: 'email',
          tabId: 'truespeed_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        phone: {
          enabled: true,
          value: '',
          outputField: 'phone',
          tabId: 'truespeed_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        comments: {
          enabled: true,
          value: '',
          outputField: 'comments',
          tabId: 'truespeed_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        technicianId: {
          enabled: true,
          value: '',
          outputField: 'technicianId',
          tabId: 'truespeed_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        upstreamCIR: {
          enabled: true,
          value: 100,
          outputField: ConfigFieldMapping.UPSTREAM_CIR,
          tabId: 'truespeed_setup'
        },
        downstreamCIR: {
          enabled: true,
          value: 100,
          outputField: ConfigFieldMapping.DOWNSTREAM_CIR,
          tabId: 'truespeed_setup'
        },
        upstreamThreshold: {
          enabled: true,
          value: 90,
          outputField: ConfigFieldMapping.UPSTREAM_THRESHOLD,
          tabId: 'truespeed_setup'
        },
        downstreamThreshold: {
          enabled: true,
          value: 90,
          outputField: ConfigFieldMapping.DOWNSTREAM_THRESHOLD,
          tabId: 'truespeed_setup'
        },
        runType: {
          enabled: true,
          value: 'on-going',
          outputField: ConfigFieldMapping.RUN_TYPE,
          tabId: 'truespeed_setup'
        },
        agentType: {
          enabled: true,
          value: 'default',
          outputField: ConfigFieldMapping.AGENT_TYPE,
          tabId: 'truespeed_setup'
        },
        testMode: {
          enabled: true,
          value: TestMode.CLIENT_TO_MA,
          outputField: ConfigFieldMapping.TEST_MODE,
          tabId: 'truespeed_setup',
          restoreOnAgentChange: true
        },
        scheduler: {
          enabled: true,
          value: { repeatInterval: 0, timeStamp: '', isValid: true },
          outputField: ConfigFieldMapping.SCHEDULER,
          tabId: 'truespeed_setup',
          restoreOnAgentChange: true
        },
        engineAInfo: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.ENGINE_A_INFO,
          tabId: 'truespeed_setup',
          restoreOnAgentChange: true
        },
        engineBInfo: {
          enabled: false,
          value: null,
          outputField: ConfigFieldMapping.ENGINE_B_INFO,
          tabId: 'truespeed_setup'
        },
        selectedOriginator: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.SELECTED_ORIGINATOR,
          tabId: 'truespeed_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        selectedDestination: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.SELECTED_DESTINATION,
          tabId: 'truespeed_setup',
          outputOptional: true
        },
        transmitInterface: {
          enabled: false,
          value: TRANSMIT_INTERFACE_VALUE.EQUIPMENT,
          outputField: ConfigFieldMapping.SRC_TRANSMIT_INTERFACE,
          tabId: 'truespeed_setup'
        },
        srcMACAddress: {
          enabled: false,
          value: '00:11:22:33:44:55',
          outputField: ConfigFieldMapping.SRC_MAC_ADDRESS,
          tabId: 'truespeed_setup'
        },
        srcNetworkMacAddress: {
          enabled: false,
          value: null,
          outputField: ConfigFieldMapping.SRC_NETWORK_MAC,
          lookup: ["capabilities.phy['network-mac']"],
          tabId: 'truespeed_setup',
          outputOptional: true
        },
        srcEquipmentMacAddress: {
          enabled: false,
          value: null,
          outputField: ConfigFieldMapping.SRC_EQUIPMENT_MAC,
          lookup: ["capabilities.phy['equipment-mac']"],
          tabId: 'truespeed_setup',
          outputOptional: true
        },
        definedAddress: {
          enabled: false,
          value: definedAddressValue.TEST_IP,
          outputField: ConfigFieldMapping.SRC_DEFINED_ADDRESS,
          tabId: 'truespeed_setup'
        },
        srcTestIpAddress: {
          enabled: false,
          value: null,
          outputField: ConfigFieldMapping.SRC_TEST_IP_ADDRESS,
          lookup: ["capabilities.phy['test-ip']"],
          tabId: 'truespeed_setup',
          outputOptional: true
        },
        srcAssignedIpAddress: {
          enabled: false,
          value: null,
          outputField: ConfigFieldMapping.SRC_ASSIGNED_IP_ADDRESS,
          lookup: ["capabilities.phy['assigned-ip']"],
          tabId: 'truespeed_setup',
          outputOptional: true
        },
        srcSubnet: {
          enabled: false,
          value: null,
          outputField: ConfigFieldMapping.SRC_SUBNET,
          lookup: ['capabilities.phy.subnet'],
          tabId: 'truespeed_setup',
          outputOptional: true
        },
        srcGateway: {
          enabled: false,
          value: null,
          outputField: ConfigFieldMapping.SRC_GATEWAY,
          lookup: ['capabilities.phy.gateway'],
          tabId: 'truespeed_setup',
          outputOptional: true
        },
        srcVlanId: {
          enabled: false,
          value: null,
          outputField: ConfigFieldMapping.SRC_VLAN_ID,
          lookup: ["capabilities.phy['test-vlan-id']"],
          tabId: 'truespeed_setup',
          outputOptional: true
        },
        destTransmitInterface: {
          enabled: false,
          value: TRANSMIT_INTERFACE_VALUE.EQUIPMENT,
          outputField: ConfigFieldMapping.DEST_TRANSMIT_INTERFACE,
          tabId: 'truespeed_setup'
        },
        destMACAddress: {
          enabled: false,
          value: '00:11:22:33:44:55',
          outputField: ConfigFieldMapping.DEST_MAC_ADDRESS,
          tabId: 'truespeed_setup'
        },
        destNetworkMacAddress: {
          enabled: false,
          value: null,
          outputField: ConfigFieldMapping.DEST_NETWORK_MAC,
          lookup: ["capabilities.phy['network-mac']"],
          tabId: 'truespeed_setup',
          outputOptional: true
        },
        destEquipmentMacAddress: {
          enabled: false,
          value: null,
          outputField: ConfigFieldMapping.DEST_EQUIPMENT_MAC,
          lookup: ["capabilities.phy['equipment-mac']"],
          tabId: 'truespeed_setup',
          outputOptional: true
        },
        destDefinedAddress: {
          enabled: false,
          value: definedAddressValue.TEST_IP,
          outputField: ConfigFieldMapping.DEST_DEFINED_ADDRESS,
          tabId: 'truespeed_setup'
        },
        destTestIpAddress: {
          enabled: false,
          value: null,
          outputField: ConfigFieldMapping.DEST_TEST_IP_ADDRESS,
          lookup: ["capabilities.phy['test-ip']"],
          tabId: 'truespeed_setup',
          outputOptional: true
        },
        destAssignedIpAddress: {
          enabled: false,
          value: null,
          outputField: ConfigFieldMapping.DEST_ASSIGNED_IP_ADDRESS,
          lookup: ["capabilities.phy['assigned-ip']"],
          tabId: 'truespeed_setup',
          outputOptional: true
        },
        destSubnet: {
          enabled: false,
          value: null,
          outputField: ConfigFieldMapping.DEST_SUBNET,
          lookup: ['capabilities.phy.subnet'],
          tabId: 'truespeed_setup',
          outputOptional: true
        },
        destGateway: {
          enabled: false,
          value: null,
          outputField: ConfigFieldMapping.DEST_GATEWAY,
          lookup: ['capabilities.phy.gateway'],
          tabId: 'truespeed_setup',
          outputOptional: true
        },
        destVlanId: {
          enabled: false,
          value: null,
          outputField: ConfigFieldMapping.DEST_VLAN_ID,
          lookup: ["capabilities.phy['test-vlan-id']"],
          tabId: 'truespeed_setup',
          outputOptional: true
        },
        expirationTimeValue: {
          enabled: false,
          value: 24,
          outputField: ConfigFieldMapping.EXPIRATION_DEFAULT_VALUE,
          tabId: 'truespeed_setup'
        },
        expirationDate: {
          enabled: false,
          value: null,
          outputField: ConfigFieldMapping.EXPIRATION_DATE,
          tabId: 'truespeed_setup'
        },
        maxExecutionCounts: {
          enabled: false,
          value: 0,
          outputField: ConfigFieldMapping.MAX_EXECUTION_COUNTS,
          tabId: 'truespeed_setup'
        },
        upstreamCIR_Advanced: {
          enabled: true,
          value: 100,
          outputField: ConfigFieldMapping.UPSTREAM_CIR,
          tabId: 'truespeed_advanced'
        },
        downstreamCIR_Advanced: {
          enabled: true,
          value: 100,
          outputField: ConfigFieldMapping.DOWNSTREAM_CIR,
          tabId: 'truespeed_advanced'
        },
        tosDscp: {
          enabled: true,
          value: { dscp: 0, type: 'dscp' },
          outputField: ConfigFieldMapping.DSCP,
          tabId: 'truespeed_advanced'
        },
        tcpPort: {
          enabled: true,
          value: 0,
          outputField: ConfigFieldMapping.TCP_PORT,
          tabId: 'truespeed_advanced'
        },
        testType: {
          enabled: true,
          value: 'truespeed',
          outputField: 'testType',
          tabId: 'truespeed_setup'
        },
        destinationIp: {
          enabled: false,
          value: null,
          outputField: ConfigFieldMapping.DESTINATION_IP,
          tabId: 'truespeed_setup',
          outputOptional: true
        },
        runExclusive: {
          enabled: false,
          value: false,
          outputField: ConfigFieldMapping.RUN_EXCLUSIVE,
          tabId: 'truespeed_advanced'
        },

        startingPercent: {
          enabled: true,
          value: 100,
          outputField: ConfigFieldMapping.STARTING_PERCENT,
          tabId: 'truespeed_advanced'
        },
        numberOfWalks: {
          enabled: true,
          value: 1,
          outputField: ConfigFieldMapping.NUMBER_OF_WALKS,
          tabId: 'truespeed_advanced'
        },
        walkDurationSeconds: {
          enabled: true,
          value: 30,
          outputField: ConfigFieldMapping.WINDOW_DURATION,
          tabId: 'truespeed_advanced'
        },
        connections: {
          enabled: true,
          value: 0,
          outputField: ConfigFieldMapping.CONNECTIONS,
          tabId: 'truespeed_advanced'
        },
        saturation: {
          enabled: true,
          value: false,
          outputField: ConfigFieldMapping.SATURATION,
          tabId: 'truespeed_advanced'
        },
        enableDynamicSaturation: {
          enabled: false,
          value: true,
          outputField: ConfigFieldMapping.ENABLE_DYNAMIC_SATURATION,
          tabId: 'truespeed_advanced'
        },
        boostWindowByPercent: {
          enabled: true,
          value: 20,
          outputField: ConfigFieldMapping.BOOST_WINDOW_PERCENT,
          tabId: 'truespeed_advanced'
        },
        boostConnectionByPercent: {
          enabled: true,
          value: 40,
          outputField: ConfigFieldMapping.BOOST_CONNECTION_PERCENT,
          tabId: 'truespeed_advanced'
        }
      },

      running: {
        add: 'anything that is different between agents in running view'
      },

      final: {
        add: 'anything that is different between agents in final report'
      },
      modes: {
        [TestMode.CLIENT_TO_MA]: {
          setup: {
            expirationTimeValue: { enabled: true },
            expirationDate: { enabled: true },
            maxExecutionCounts: { enabled: true },
            engineBInfo: { enabled: false }
          }
        },
        [TestMode.MA_TO_JMEP]: {
          setup: {
            destinationIp: { enabled: true }
          }
        }
      }
    },

    [AGENT_MODEL.VTA]: {
      setup: {
        runExclusive: { enabled: true },
        engineBInfo: { enabled: true }
      },
      modes: {
        [TestMode.MA_TO_MA]: {
          setup: {
            transmitInterface: { enabled: true },
            definedAddress: { enabled: true },
            srcNetworkMacAddress: { enabled: true },
            srcEquipmentMacAddress: { enabled: true },
            srcTestIpAddress: { enabled: true },
            srcAssignedIpAddress: { enabled: true },
            srcSubnet: { enabled: true },
            srcGateway: { enabled: true },
            srcVlanId: { enabled: true },
            destTransmitInterface: { enabled: true },
            destDefinedAddress: { enabled: true },
            destNetworkMacAddress: { enabled: true },
            destEquipmentMacAddress: { enabled: true },
            destTestIpAddress: { enabled: true },
            destAssignedIpAddress: { enabled: true },
            destSubnet: { enabled: true },
            destGateway: { enabled: true },
            destVlanId: { enabled: true }
          }
        },
        [TestMode.MA_TO_JMEP]: {
          setup: {
            destinationIp: { enabled: true }
          }
        }
      },
      versions: {
        /* if vta has newer versions then the differences can be put here */
        '2.0': {
          setup: {},
          running: {},
          final: {}
        }
      }
    },
    [AGENT_MODEL.VQT]: {
      setup: {
        engineBInfo: { enabled: true }
      },
      versions: {
        /* if vta has newer versions then the differences can be put here */
        '2.0': {
          setup: {},
          running: {},
          final: {}
        }
      }
    },
    [AGENT_MODEL.VSPA_SAT]: {
      setup: {
        runExclusive: { enabled: true },
        engineBInfo: { enabled: true }
      },
      modes: {
        [TestMode.MA_TO_MA]: {
          setup: {
            transmitInterface: { enabled: true },
            definedAddress: { enabled: true },
            srcNetworkMacAddress: { enabled: true },
            srcEquipmentMacAddress: { enabled: true },
            srcTestIpAddress: { enabled: true },
            srcAssignedIpAddress: { enabled: true },
            srcSubnet: { enabled: true },
            srcGateway: { enabled: true },
            srcVlanId: { enabled: true },
            destTransmitInterface: { enabled: true },
            destDefinedAddress: { enabled: true },
            destNetworkMacAddress: { enabled: true },
            destEquipmentMacAddress: { enabled: true },
            destTestIpAddress: { enabled: true },
            destAssignedIpAddress: { enabled: true },
            destSubnet: { enabled: true },
            destGateway: { enabled: true },
            destVlanId: { enabled: true }
          }
        },
        [TestMode.MA_TO_JMEP]: {
          setup: {
            destinationIp: { enabled: true }
          }
        }
      }
    },
    [AGENT_MODEL.NSC]: {
      setup: {
        runExclusive: { enabled: true },
        engineBInfo: { enabled: true }
      }
    },

    [AGENT_MODEL.VTA_TS]: {
      setup: {
        engineBInfo: { enabled: true }
      },
      modes: {
        [TestMode.CLIENT_TO_MA]: {
          setup: {
            expirationTimeValue: { enabled: true },
            expirationDate: { enabled: true },
            maxExecutionCounts: { enabled: true },
            engineBInfo: { enabled: false },
            enableDynamicSaturation: { enabled: true }
          }
        },
        [TestMode.MA_TO_MA]: {
          setup: {
            transmitInterface: { enabled: true },
            definedAddress: { enabled: true },
            srcNetworkMacAddress: { enabled: true },
            srcEquipmentMacAddress: { enabled: true },
            srcTestIpAddress: { enabled: true },
            srcAssignedIpAddress: { enabled: true },
            srcSubnet: { enabled: true },
            srcGateway: { enabled: true },
            srcVlanId: { enabled: true },
            destTransmitInterface: { enabled: true },
            destDefinedAddress: { enabled: true },
            destNetworkMacAddress: { enabled: true },
            destEquipmentMacAddress: { enabled: true },
            destTestIpAddress: { enabled: true },
            destAssignedIpAddress: { enabled: true },
            destSubnet: { enabled: true },
            destGateway: { enabled: true },
            destVlanId: { enabled: true }
          }
        }
      }
    },
    [AGENT_MODEL.VSPA_SAT_TS]: {
      setup: {
        engineBInfo: { enabled: true }
      },
      modes: {
        [TestMode.CLIENT_TO_MA]: {
          setup: {
            expirationTimeValue: { enabled: true },
            expirationDate: { enabled: true },
            maxExecutionCounts: { enabled: true },
            engineBInfo: { enabled: false },
            enableDynamicSaturation: { enabled: true }
          }
        },
        [TestMode.MA_TO_MA]: {
          setup: {
            transmitInterface: { enabled: true },
            definedAddress: { enabled: true },
            srcNetworkMacAddress: { enabled: true },
            srcEquipmentMacAddress: { enabled: true },
            srcTestIpAddress: { enabled: true },
            srcAssignedIpAddress: { enabled: true },
            srcSubnet: { enabled: true },
            srcGateway: { enabled: true },
            srcVlanId: { enabled: true },
            destTransmitInterface: { enabled: true },
            destDefinedAddress: { enabled: true },
            destNetworkMacAddress: { enabled: true },
            destEquipmentMacAddress: { enabled: true },
            destTestIpAddress: { enabled: true },
            destAssignedIpAddress: { enabled: true },
            destSubnet: { enabled: true },
            destGateway: { enabled: true },
            destVlanId: { enabled: true }
          }
        }
      }
    },
    [AGENT_MODEL.MAP2100]: {
      setup: {
        runExclusive: { enabled: true },
        engineBInfo: { enabled: true }
      },
      modes: {
        [TestMode.CLIENT_TO_MA]: {
          setup: {
            expirationTimeValue: { enabled: true },
            expirationDate: { enabled: true },
            maxExecutionCounts: { enabled: true },
            engineBInfo: { enabled: false },
            enableDynamicSaturation: { enabled: true }
          }
        }
      }
    },

    [AGENT_MODEL.QT600]: {
      setup: {
        runExclusive: { enabled: true },
        engineBInfo: { enabled: true }
      },
      modes: {
        [TestMode.CLIENT_TO_MA]: {
          setup: {
            expirationTimeValue: { enabled: true },
            expirationDate: { enabled: true },
            maxExecutionCounts: { enabled: true },
            engineBInfo: { enabled: false },
            enableDynamicSaturation: { enabled: true }
          }
        }
      }
    },
    [AGENT_MODEL.JMEP_10G]: {
      setup: {
        engineBInfo: { enabled: true }
      },
      modes: {
        [TestMode.MA_TO_MA]: {
          setup: {
            runExclusive: { enabled: true, value: true },
            transmitInterface: { enabled: true },
            definedAddress: { enabled: true },
            srcNetworkMacAddress: { enabled: true },
            srcEquipmentMacAddress: { enabled: true },
            srcTestIpAddress: { enabled: true },
            srcAssignedIpAddress: { enabled: true },
            srcSubnet: { enabled: true },
            srcGateway: { enabled: true },
            srcVlanId: { enabled: true },
            destTransmitInterface: { enabled: true },
            destDefinedAddress: { enabled: true },
            destNetworkMacAddress: { enabled: true },
            destEquipmentMacAddress: { enabled: true },
            destTestIpAddress: { enabled: true },
            destAssignedIpAddress: { enabled: true },
            destSubnet: { enabled: true },
            destGateway: { enabled: true },
            destVlanId: { enabled: true }
          }
        }
      }
    }
  }
};
